'use client';

import React__default, { useContext, useState, useMemo, useEffect } from 'react';
import { ChildrenSearchFilterWrapper, ParentWrapper, ChildrenItemWrapper } from './ChildrenSearchFilter.css.js';
import { CascaderContext } from '../../../../context/reducer.js';
import { filterResultByAPI, getParentCheckState, countSelectedChildrenFromParentId, getChildrenCheckState } from '../../../../helper.js';
import { ParentTitle } from '../RightColumnContent/RightColumnContent.css.js';
import DropdownItem from '../DropdownItem/index.js';
import { ACTIONS } from '../../../../context/actions.js';
import useDebounce from '../../../../../Utils/hooks.js';
import { ELanguage } from '../../../../../Utils/constants.js';

var ChildrenSearchFilter = function () {
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state, t = _a.t, dispatch = _a.dispatch;
    var options = props.options, langCode = props.langCode, isMobile = props.isMobile;
    var _b = options.parent, parent = _b === void 0 ? [] : _b, children = options.children;
    var keyword = state.keyword, parentId = state.parentId, temporaryValue = state.temporaryValue, searchResult = state.searchResult;
    var _c = useState(true), isLockAutoFocus = _c[0], setLockAutoFocus = _c[1];
    var debounceKeyword = useDebounce([keyword], 300);
    var _d = useMemo(function () {
        return filterResultByAPI({
            searchResult: searchResult,
            parent: parent,
            children: children,
            keyword: keyword,
            langCode: langCode
        });
    }, [children, keyword, langCode, parent, searchResult]), filteredParent = _d[0], filteredChildren = _d[1];
    useEffect(function () {
        // No result found and already focus
        if (filteredParent.length === 0 && parentId !== -1) {
            dispatch({
                type: ACTIONS.REMOVE_SELECTED_OR_HOVER
            });
            return;
        }
        if (filteredParent.length === 0) {
            return;
        }
        if (isLockAutoFocus) {
            return;
        }
        // Lock dispatch and it should only work on desktop
        if (isMobile) {
            return;
        }
        // Prevent set parentId multiple time even it is same value
        if (parentId === filteredParent[0].id) {
            return;
        }
        setLockAutoFocus(true);
        // Auto selected first parent
        dispatch({
            type: ACTIONS.SET_SELECT_PARENT_ID,
            payload: filteredParent[0].id
        });
    }, [isLockAutoFocus, filteredParent, parentId, isMobile]);
    useEffect(function () {
        if (!debounceKeyword) {
            return;
        }
        setLockAutoFocus(false);
    }, [debounceKeyword]);
    return (React__default.createElement(ChildrenSearchFilterWrapper, { isMobile: isMobile },
        filteredParent.length > 0 ? (React__default.createElement(ParentWrapper, { isBorder: filteredChildren.length > 0 }, filteredParent.map(function (item, index) {
            var _a;
            var checkState = getParentCheckState(item.id, temporaryValue);
            var countChildren = countSelectedChildrenFromParentId(item.id, temporaryValue);
            return (React__default.createElement(DropdownItem, { key: "search-parent-item-".concat(index), checkState: checkState, label: item.name, id: item.id, parentId: item.id, isSelected: parentId === item.id, isSelectedValue: false, isHaveChildren: true, jobCount: (_a = item.jobs) !== null && _a !== void 0 ? _a : 0, selectedCount: countChildren, isHighlightText: true }));
        }))) : null,
        filteredChildren.length > 0
            ? filteredChildren.map(function (item, index) {
                return (React__default.createElement(ChildrenItemWrapper, { key: "child-search-item-".concat(index) },
                    React__default.createElement(ParentTitle, null, item.parentName),
                    item.childrens.map(function (childItem) {
                        var _a;
                        var parentCheckState = getParentCheckState(item.parentId, temporaryValue);
                        var itemCheckState = 'none';
                        if (parentCheckState === 'checked') {
                            itemCheckState = 'checked';
                        }
                        else if (parentCheckState === 'half') {
                            // Get item check state
                            itemCheckState = getChildrenCheckState(item.parentId, childItem.id, temporaryValue);
                        }
                        return (React__default.createElement(DropdownItem, { key: "child-item-".concat(childItem.id), checkState: itemCheckState, label: langCode === ELanguage.EN ? childItem.nameEn : childItem.name, id: childItem.id, parentId: item.parentId, isHaveChildren: false, isSelected: false, isSelectedValue: false, jobCount: (_a = childItem.jobs) !== null && _a !== void 0 ? _a : 0, isHighlightText: true }));
                    })));
            })
            : null,
        filteredChildren.length === 0 && filteredParent.length === 0 && React__default.createElement("p", null, t('No result'))));
};

export { ChildrenSearchFilter as default };
//# sourceMappingURL=index.js.map
